// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as CatalogProduct from "../Catalog/CatalogProduct.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";
import * as ProductStockTableCell from "../Product/ProductStockTableCell.res.js";
import * as ProductReferenceTableCell from "../Product/ProductReferenceTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query VariantsQuery($search: String, $filterBy: InputVariantsDistinctOnCkuQueryFilter, $after: String, $first: Int)  {\nvariantsDistinctOnCku(search: $search, filterBy: $filterBy, after: $after, first: $first)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncku  \ncreatedAt  \nname  \nformattedName  \nproduct  {\n__typename  \nid  \nname  \nkind  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\nstockKeepingUnit  \ninternalCode  \npriceLookUpCode  \nsupplier  {\n__typename  \ncompanyName  \n}\n\nformattedCategory  \nalcoholVolume  \nformattedPurchasedPrice  \nbulk  \nstock  {\n__typename  \nrawQuantity  \nformattedQuantity  \nstate  \n}\n\n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variantsDistinctOnCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$2.hasNextPage;
  let value$6 = value$1.edges;
  return {
    variantsDistinctOnCku: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined,
        hasNextPage: !(value$5 == null) ? value$5 : undefined
      },
      edges: value$6.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.product;
        let value$3 = value$2.kind;
        let tmp;
        switch (value$3) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$2.color;
        let tmp$1;
        if (value$4 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$4) {
            case "AMBER" :
              tmp$2 = "AMBER";
              break;
            case "BLACK" :
              tmp$2 = "BLACK";
              break;
            case "BLOND" :
              tmp$2 = "BLOND";
              break;
            case "DARK" :
              tmp$2 = "DARK";
              break;
            case "ORANGE" :
              tmp$2 = "ORANGE";
              break;
            case "RED" :
              tmp$2 = "RED";
              break;
            case "ROSE" :
              tmp$2 = "ROSE";
              break;
            case "WHITE" :
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$5 = value$2.wineType;
        let tmp$3;
        if (value$5 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$5) {
            case "EFFERVESCENT" :
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL" :
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$6 = value$2.whiteWineType;
        let tmp$5;
        if (value$6 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$6) {
            case "DRY" :
              tmp$6 = "DRY";
              break;
            case "SEMIDRY" :
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT" :
              tmp$6 = "SOFT";
              break;
            case "SWEET" :
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$7 = value$2.beerType;
        let value$8 = value$2.producer;
        let value$9 = value$2.designation;
        let value$10 = value$2.family;
        let value$11 = value$2.region;
        let value$12 = value$2.country;
        let value$13 = value$2.tax;
        let value$14 = value$1.stockKeepingUnit;
        let value$15 = value$1.internalCode;
        let value$16 = value$1.priceLookUpCode;
        let value$17 = value$1.supplier;
        let value$18 = value$1.formattedCategory;
        let value$19 = value$1.alcoholVolume;
        let value$20 = value$1.formattedPurchasedPrice;
        let value$21 = value$1.bulk;
        let value$22 = value$1.stock;
        let value$23 = value$22.rawQuantity;
        let value$24 = value$22.formattedQuantity;
        let value$25 = value$22.state;
        let tmp$7;
        if (value$25 == null) {
          tmp$7 = undefined;
        } else {
          let tmp$8;
          switch (value$25) {
            case "ALERT" :
              tmp$8 = "ALERT";
              break;
            case "DANGER" :
              tmp$8 = "DANGER";
              break;
            case "OK" :
              tmp$8 = "OK";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$7 = tmp$8;
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            cku: Scalar.CKU.parse(value$1.cku),
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            name: value$1.name,
            formattedName: value$1.formattedName,
            product: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              kind: tmp,
              color: tmp$1,
              wineType: tmp$3,
              whiteWineType: tmp$5,
              beerType: !(value$7 == null) ? value$7 : undefined,
              producer: !(value$8 == null) ? value$8 : undefined,
              designation: !(value$9 == null) ? value$9 : undefined,
              family: !(value$10 == null) ? value$10 : undefined,
              region: !(value$11 == null) ? value$11 : undefined,
              country: !(value$12 == null) ? value$12 : undefined,
              tax: {
                __typename: value$13.__typename,
                value: value$13.value
              }
            },
            stockKeepingUnit: !(value$14 == null) ? value$14 : undefined,
            internalCode: !(value$15 == null) ? value$15 : undefined,
            priceLookUpCode: !(value$16 == null) ? value$16 : undefined,
            supplier: !(value$17 == null) ? ({
                __typename: value$17.__typename,
                companyName: value$17.companyName
              }) : undefined,
            formattedCategory: !(value$18 == null) ? value$18 : undefined,
            alcoholVolume: !(value$19 == null) ? value$19 : undefined,
            formattedPurchasedPrice: !(value$20 == null) ? value$20 : undefined,
            bulk: !(value$21 == null) ? value$21 : undefined,
            stock: {
              __typename: value$22.__typename,
              rawQuantity: !(value$23 == null) ? value$23 : undefined,
              formattedQuantity: !(value$24 == null) ? value$24 : undefined,
              state: tmp$7
            }
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}

function serialize(value) {
  let value$1 = value.variantsDistinctOnCku;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.stock;
    let value$3 = value$2.state;
    let state = value$3 !== undefined ? (
        value$3 === "OK" ? "OK" : (
            value$3 === "ALERT" ? "ALERT" : "DANGER"
          )
      ) : null;
    let value$4 = value$2.formattedQuantity;
    let formattedQuantity = value$4 !== undefined ? value$4 : null;
    let value$5 = value$2.rawQuantity;
    let rawQuantity = value$5 !== undefined ? value$5 : null;
    let value$6 = value$2.__typename;
    let stock = {
      __typename: value$6,
      rawQuantity: rawQuantity,
      formattedQuantity: formattedQuantity,
      state: state
    };
    let value$7 = value$1.bulk;
    let bulk = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.formattedPurchasedPrice;
    let formattedPurchasedPrice = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.alcoholVolume;
    let alcoholVolume = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.formattedCategory;
    let formattedCategory = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.supplier;
    let supplier;
    if (value$11 !== undefined) {
      let value$12 = value$11.companyName;
      let value$13 = value$11.__typename;
      supplier = {
        __typename: value$13,
        companyName: value$12
      };
    } else {
      supplier = null;
    }
    let value$14 = value$1.priceLookUpCode;
    let priceLookUpCode = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.internalCode;
    let internalCode = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$16 !== undefined ? value$16 : null;
    let value$17 = value$1.product;
    let value$18 = value$17.tax;
    let value$19 = value$18.value;
    let value$20 = value$18.__typename;
    let tax = {
      __typename: value$20,
      value: value$19
    };
    let value$21 = value$17.country;
    let country = value$21 !== undefined ? value$21 : null;
    let value$22 = value$17.region;
    let region = value$22 !== undefined ? value$22 : null;
    let value$23 = value$17.family;
    let family = value$23 !== undefined ? value$23 : null;
    let value$24 = value$17.designation;
    let designation = value$24 !== undefined ? value$24 : null;
    let value$25 = value$17.producer;
    let producer = value$25 !== undefined ? value$25 : null;
    let value$26 = value$17.beerType;
    let beerType = value$26 !== undefined ? value$26 : null;
    let value$27 = value$17.whiteWineType;
    let whiteWineType = value$27 !== undefined ? (
        value$27 === "SWEET" ? "SWEET" : (
            value$27 === "SEMIDRY" ? "SEMIDRY" : (
                value$27 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : null;
    let value$28 = value$17.wineType;
    let wineType = value$28 !== undefined ? (
        value$28 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : null;
    let value$29 = value$17.color;
    let color = value$29 !== undefined ? (
        value$29 === "ORANGE" ? "ORANGE" : (
            value$29 === "RED" ? "RED" : (
                value$29 === "AMBER" ? "AMBER" : (
                    value$29 === "DARK" ? "DARK" : (
                        value$29 === "BLACK" ? "BLACK" : (
                            value$29 === "BLOND" ? "BLOND" : (
                                value$29 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$30 = value$17.kind;
    let kind = value$30 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$30 === "BEER" ? "BEER" : (
            value$30 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$31 = value$17.name;
    let value$32 = value$17.id;
    let value$33 = value$17.__typename;
    let product = {
      __typename: value$33,
      id: value$32,
      name: value$31,
      kind: kind,
      color: color,
      wineType: wineType,
      whiteWineType: whiteWineType,
      beerType: beerType,
      producer: producer,
      designation: designation,
      family: family,
      region: region,
      country: country,
      tax: tax
    };
    let value$34 = value$1.formattedName;
    let value$35 = value$1.name;
    let value$36 = value$1.createdAt;
    let value$37 = Scalar.Datetime.serialize(value$36);
    let value$38 = value$1.cku;
    let value$39 = Scalar.CKU.serialize(value$38);
    let value$40 = value$1.id;
    let value$41 = value$1.__typename;
    let node = {
      __typename: value$41,
      id: value$40,
      cku: value$39,
      createdAt: value$37,
      name: value$35,
      formattedName: value$34,
      product: product,
      stockKeepingUnit: stockKeepingUnit,
      internalCode: internalCode,
      priceLookUpCode: priceLookUpCode,
      supplier: supplier,
      formattedCategory: formattedCategory,
      alcoholVolume: alcoholVolume,
      formattedPurchasedPrice: formattedPurchasedPrice,
      bulk: bulk,
      stock: stock
    };
    let value$42 = value.__typename;
    return {
      __typename: value$42,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.hasNextPage;
  let hasNextPage = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.endCursor;
  let endCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.startCursor;
  let startCursor = value$7 !== undefined ? value$7 : null;
  let value$8 = value$4.__typename;
  let pageInfo = {
    __typename: value$8,
    startCursor: startCursor,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$9 = value$1.__typename;
  let variantsDistinctOnCku = {
    __typename: value$9,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    variantsDistinctOnCku: variantsDistinctOnCku
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputVariantsDistinctOnCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.active;
  let a$2 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    active: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    archived: a$2 !== undefined ? (
        a$2 === "ONLY" ? "ONLY" : (
            a$2 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.after;
  let a$3 = inp.first;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputVariantsDistinctOnCkuQueryFilter(a$1) : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined
  };
}

function makeVariables(search, filterBy, after, first) {
  return {
    search: search,
    filterBy: filterBy,
    after: after,
    first: first
  };
}

function makeInputObjectInputVariantsDistinctOnCkuQueryFilter(shopIds, active, archived, param) {
  return {
    shopIds: shopIds,
    active: active,
    archived: archived
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    filterBy: undefined,
    after: undefined,
    first: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsDistinctOnCkuQueryFilter: serializeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsDistinctOnCkuQueryFilter: makeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsDistinctOnCkuQueryFilter: serializeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsDistinctOnCkuQueryFilter: makeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function rowsFromEdgesData(data) {
  return data.map(edge => ({
    id: edge.node.id,
    cku: edge.node.cku,
    createdAt: edge.node.createdAt,
    formattedName: edge.node.formattedName,
    productKind: edge.node.product.kind,
    information: {
      productName: edge.node.product.name,
      variantName: edge.node.name,
      sku: edge.node.stockKeepingUnit,
      plu: Stdlib_Option.map(edge.node.priceLookUpCode, plu => plu.toString()),
      internalCode: edge.node.internalCode,
      color: edge.node.product.color,
      producerName: edge.node.product.producer,
      designation: edge.node.product.designation,
      productFamily: edge.node.product.family,
      wineType: edge.node.product.wineType,
      whiteWineType: edge.node.product.whiteWineType,
      beerType: edge.node.product.beerType,
      region: edge.node.product.region,
      country: Stdlib_Option.getOr(edge.node.product.country, "—"),
      categoryName: Stdlib_Option.getOr(edge.node.formattedCategory, "—"),
      supplierName: Stdlib_Option.map(edge.node.supplier, supplier => supplier.companyName),
      alcoholVolume: Stdlib_Option.map(edge.node.alcoholVolume, alcoholVolume => I18n.decimalFormat(undefined, undefined, 1, undefined, alcoholVolume) + "°")
    },
    purchasePrice: edge.node.formattedPurchasedPrice,
    stockRawQuantity: Stdlib_Option.getOr(edge.node.stock.rawQuantity, 0),
    stockFormattedQuantity: Stdlib_Option.getOr(edge.node.stock.formattedQuantity, "—"),
    stockState: edge.node.stock.state,
    bulk: Stdlib_Option.getOr(edge.node.bulk, false)
  }));
}

let columns = [
  {
    key: "reference",
    name: I18n.t("Product"),
    layout: {
      width: {
        NAME: "pct",
        VAL: 65
      },
      margin: "large"
    },
    render: param => {
      let product = param.data;
      let badgeNew = DateHelpers.diffInHours(new Date(), product.createdAt) <= 24 ? ({
          variation: "information",
          text: I18n.t("New")
        }) : undefined;
      return JsxRuntime.jsx(ProductReferenceTableCell.make, {
        badge: badgeNew,
        disabled: param.disabled,
        productKind: product.productKind,
        information: product.information
      });
    }
  },
  {
    key: "stock",
    name: I18n.t("Stock exp."),
    render: param => {
      let product = param.data;
      if (param.disabled) {
        return JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Already added"),
          variation: "subdued",
          size: "small"
        });
      } else {
        return JsxRuntime.jsx(ProductStockTableCell.make, {
          value: product.stockFormattedQuantity,
          state: product.stockState,
          size: "xsmall"
        });
      }
    }
  },
  {
    key: "purchasedPrice",
    name: I18n.t("Purchase price"),
    layout: {
      width: {
        NAME: "px",
        VAL: 120
      }
    },
    render: param => {
      if (param.disabled) {
        return null;
      } else {
        return JsxRuntime.jsx(ProductPriceTableCell.make, {
          value: param.data.purchasePrice,
          size: "xsmall"
        });
      }
    }
  }
];

function setTransferredQuantityValue(product) {
  return {
    cku: product.cku,
    name: product.name,
    description: product.description,
    purchasePrice: product.purchasePrice,
    stockKeepingUnit: product.stockKeepingUnit,
    senderVariantId: product.senderVariantId,
    senderStockQuantity: product.senderStockQuantity,
    senderStockState: product.senderStockState,
    recipientVariantId: product.recipientVariantId,
    recipientStockQuantity: product.recipientStockQuantity,
    recipientStockState: product.recipientStockState,
    transferredQuantity: 1
  };
}

let make = React.memo(props => {
  let onCommit = props.onCommit;
  let selectedProducts = props.selectedProducts;
  let renderStartText = () => {
    let length = selectedProducts.length;
    let shouldBePrimaryView = length > 0;
    let formattedText = length.toString() + ` ` + I18n.t(I18n.isPlural(length) ? "selected products" : "selected product");
    return JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: formattedText,
        variation: shouldBePrimaryView ? "primary" : "neutral",
        weight: shouldBePrimaryView ? "strong" : "regular"
      })
    });
  };
  let onCommit$1 = () => onCommit(selectedProducts.filter(row => !row.bulk).map(row => setTransferredQuantityValue({
    cku: row.cku,
    name: row.formattedName,
    description: CatalogProduct.Information.formatDescription(row.productKind, row.information, undefined, undefined, undefined, undefined),
    purchasePrice: row.purchasePrice,
    stockKeepingUnit: row.information.sku,
    senderVariantId: row.id,
    senderStockQuantity: row.stockRawQuantity,
    senderStockState: row.stockState,
    recipientVariantId: "",
    recipientStockQuantity: undefined,
    recipientStockState: undefined,
    transferredQuantity: 0
  })));
  return JsxRuntime.jsx(Modal.make, {
    children: props.children,
    opened: props.opened,
    title: I18n.t("Product append"),
    variation: "secondary",
    compact: false,
    backgroundColor: "#fefefe",
    renderStartText: renderStartText,
    abortButtonText: I18n.t("Cancel"),
    allowCommit: selectedProducts.length !== 0,
    commitButtonTone: "brand",
    commitButtonText: I18n.t("Add products"),
    commitButtonCallback: onCommit$1,
    onRequestClose: props.onRequestClose
  });
});

let PickerModal = {
  setTransferredQuantityValue: setTransferredQuantityValue,
  make: make
};

function makeVariables$1(search, shopId, after, param) {
  return makeVariables(search, {
    shopIds: {
      _in: [shopId]
    },
    active: undefined,
    archived: undefined
  }, after, 20);
}

function initialState() {
  return {
    searchQuery: "",
    selectedProducts: []
  };
}

function make$1(state, action) {
  if (action.TAG === "Searched") {
    return {
      searchQuery: action._0,
      selectedProducts: state.selectedProducts
    };
  }
  let allProducts = action._1;
  let tableSelection = action._0;
  let prev = state.selectedProducts;
  let selectedProducts;
  selectedProducts = typeof tableSelection !== "object" ? prev : Stdlib_Array.filterMap(tableSelection._0, selectedRowId => allProducts.concat(prev).find(row => row.id === selectedRowId));
  return {
    searchQuery: state.searchQuery,
    selectedProducts: selectedProducts
  };
}

let Reducer = {
  initialState: initialState,
  make: make$1
};

function StockTransferFormProductPickerModalTable(props) {
  let __disabledIds = props.disabledIds;
  let recipientShopId = props.recipientShopId;
  let senderShopId = props.senderShopId;
  let opened = props.opened;
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let initialState_selectedProducts = [];
  let initialState = {
    searchQuery: "",
    selectedProducts: initialState_selectedProducts
  };
  let match = React.useReducer(make$1, initialState);
  let dispatch = match[1];
  let state = match[0];
  let query = use(undefined, undefined, undefined, undefined, "NetworkOnly", "CacheFirst", undefined, true, undefined, undefined, undefined, undefined, senderShopId === "" || recipientShopId === "", undefined, makeVariables$1(state.searchQuery, senderShopId, undefined, undefined));
  let asyncResult = ApolloHelpers.useQueryResultToAsyncResultWithVariablesReloading2(query, state.searchQuery, senderShopId);
  let data = AsyncResult.mapOk(asyncResult, data => rowsFromEdgesData(data.variantsDistinctOnCku.edges));
  React.useEffect(() => {
    if (!opened && state.searchQuery !== "") {
      dispatch({
        TAG: "Searched",
        _0: ""
      });
    }
  }, [opened]);
  let onLoadMore = React.useCallback(() => {
    if (typeof asyncResult !== "object") {
      return;
    }
    if (asyncResult.TAG !== "Done") {
      return;
    }
    let data = asyncResult._0;
    if (data.TAG !== "Ok") {
      return;
    }
    let data$1 = data._0;
    if (data$1.variantsDistinctOnCku.pageInfo.hasNextPage === true) {
      query.fetchMore(undefined, undefined, makeVariables$1(state.searchQuery, senderShopId, data$1.variantsDistinctOnCku.pageInfo.endCursor, undefined), (prevResult, param) => {
        let fetchMoreResult = param.fetchMoreResult;
        if (fetchMoreResult === undefined) {
          return prevResult;
        }
        let newVariants = fetchMoreResult.variantsDistinctOnCku;
        return {
          variantsDistinctOnCku: {
            __typename: newVariants.__typename,
            pageInfo: newVariants.pageInfo,
            edges: prevResult.variantsDistinctOnCku.edges.concat(newVariants.edges),
            totalCount: newVariants.totalCount
          }
        };
      }, undefined);
      return;
    }
  }, [asyncResult]);
  let onSelectChange = React.useCallback(selection => {
    let rowsData;
    if (typeof data !== "object") {
      rowsData = data === "NotAsked" ? [] : [];
    } else if (data.TAG === "Reloading") {
      let data$1 = data._0;
      rowsData = data$1.TAG === "Ok" ? data$1._0 : [];
    } else {
      let data$2 = data._0;
      rowsData = data$2.TAG === "Ok" ? data$2._0 : [];
    }
    dispatch({
      TAG: "ProductSelectionUpdated",
      _0: selection,
      _1: rowsData
    });
  }, [
    data,
    disabledIds
  ]);
  let placeholderEmptyState = senderShopId !== "" && recipientShopId !== "" ? JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query"),
        onPress: () => dispatch({
          TAG: "Searched",
          _0: ""
        })
      })
    }) : JsxRuntime.jsx(Placeholder.make, {
      status: {
        TAG: "Pending",
        title: I18n.t("Beware !"),
        message: I18n.t("Please select the shops linked to the transfer to start adding products."),
        illustration: Primitive_option.some(Illustration.shopMissing)
      }
    });
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(AnimatedRender.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(TableView.make, {
          data: data,
          columns: columns,
          keyExtractor: row => row.id,
          disabledRowsKeys: disabledIds,
          selectionEnabled: true,
          selectAllEnabled: false,
          hideReloadingPlaceholder: true,
          compactRows: true,
          placeholderEmptyState: placeholderEmptyState,
          searchQuery: state.searchQuery,
          searchPlaceholder: I18n.t("Search product"),
          onSearchQueryChange: value => dispatch({
            TAG: "Searched",
            _0: value
          }),
          onLoadMore: onLoadMore,
          onSelectChange: onSelectChange
        }),
        style: {
          display: "flex",
          maxHeight: "70vh",
          minHeight: "70vh"
        }
      }),
      displayed: opened,
      animation: "fadePopinTranslation",
      duration: 300
    }),
    opened: opened,
    selectedProducts: state.selectedProducts,
    onCommit: props.onCommit,
    onRequestClose: props.onRequestClose
  });
}

let make$2 = React.memo(StockTransferFormProductPickerModalTable, (oldProps, newProps) => {
  if (oldProps.opened === newProps.opened && oldProps.senderShopId === newProps.senderShopId) {
    return oldProps.recipientShopId === newProps.recipientShopId;
  } else {
    return false;
  }
});

export {
  Query,
  rowsFromEdgesData,
  columns,
  PickerModal,
  makeVariables$1 as makeVariables,
  Reducer,
  make$2 as make,
}
/* query Not a pure module */
